import { InputOutputForm } from './shared/input-output-form'
import { InputOutputFormProps } from './shared/input-output-form/types'

// Re-export for backward compatibility
export { InputOutputExamples } from './shared/input-output-form/examples'

export function InputOutputToDWLForm(props: InputOutputFormProps) {
  return <InputOutputForm {...props} />
}
